import React from 'react';

const TopLeft1Shape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="369" 
      height="388" 
      viewBox="0 0 369 388" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
    <path 
      d="M-30.6066 133.629L-71.3134 100.057L-22.0258 -58.2068L157.385 -201.144L368.722 -250.25L361.088 -43.4467L328.721 122.276L296.354 287.998C288.341 366.81 239.277 387.323 215.746 387.728C102.042 377.698 30.9332 256.86 9.5918 197.694C-1.83988 165.926 -21.9703 141.747 -30.6066 133.629Z" 
      fill="white"/>
    </svg>
  );
};

export default TopLeft1Shape;
